export default __webpack_public_path__ + "af470374a461e634e35ae3689179caa5.svg";